import React from 'react';
import {Message} from 'semantic-ui-react';

export const ErrorMessages = ({error = {}}) => {
  const hasErrors = error && !!(error.errors || []).length;
  return (
    hasErrors && (
      <Message negative>
        {(error.errors || []).map(x => (
          <p key={x.errorMessage}>{x.errorMessage}</p>
        ))}
      </Message>
    )
  );
};
